import { createContext } from "react";

export const ProjectLiveChatContext = createContext({
  canUseProjectLiveChat: false,
  openProjectLiveChat: () => false,
  closeProjectLiveChat: () => {},
  getProjectLiveChatUnreadCount: () => 0,
  watchProjectLiveChat: () => () => {},
  projectLiveChatUnreadRevision: 0,
});
